module.exports = __webpack_public_path__ + "img/banner_library.09cde462.jpg";